<template>
  <v-list dense>
    <v-list-item
      link
      v-for="(menuItem, key) in menuItems"
      :key="key"
      @click="$router.push(menuItem.link)"
    >
      <v-list-item-action>
        <v-icon>{{ menuItem.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import store from "../store";

export default {
  name: "Menu",
  computed: {
    menuItems() {
      return store.menu.filter(item => {
        return item.types.indexOf(store.currentUser.type) >= 0;
      });
    }
  }
};
</script>
